require('select2');

/**
 * select2 ma kod v blocich jako "S2.define('select2/translation',..."
 * tento kod provadi drobne zmeny ve vybranych blocich
 *
 */

$.fn.select2.amd.require('select2/selection/search').prototype.render = function (decorated) {
    var $search = $(
        /*'<span class="select2-search select2-search--inline">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocorrect="off" autocapitalize="none"' +
        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
        '</span>'*/
        '<span class="select2-search select2-search--inline">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocorrect="off" autocapitalize="none"' +
        ' autocomplete="off" ' +
        ' spellcheck="false" role="presentation" aria-autocomplete="none" />' +
        '</span>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    this.$search.prop('autocomplete', this.options.get('autocomplete'));

    var $rendered = decorated.call(this);

    this._transferTabIndex();
    $rendered.append(this.$searchContainer);

    return $rendered;
};


var originalBind = $.fn.select2.amd.require('select2/selection/multiple').prototype.bind;
$.fn.select2.amd.require('select2/selection/multiple').prototype.bind = function (container, $container) {
    // tahle funkce dela to, ze kdyz volim mesto se vzdalenosti, tak je tam dalsi select na tu vzdalenost
    // bez teto upravy by kliknuti na select vzdalenosti spustilo i select na vyber mesta

    originalBind.apply(this, arguments);
    //tohle je divny, protoze odebiram a opet pridavam event, ktery je i v puvodni implementaci, ale jen takhle to funguje
    this.$selection.off('click', '.search-custom-html-element');
    this.$selection.on(
        'click',
        '.search-custom-html-element',
        function (evt) {
            evt.stopPropagation();
        }
    );
};


$.fn.select2.amd.require('select2/dropdown/search').prototype.render = function (decorated) {
    var $rendered = decorated.call(this);

    var $search = $(
        /* original:
        '<span class="select2-search select2-search--dropdown">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocorrect="off" autocapitalize="none"' +
        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
        '</span>'
        */
        '<span class="select2-search select2-search--dropdown">' +
        '<input class="select2-search__field" type="search" tabindex="-1"' +
        ' autocorrect="off" autocapitalize="none"' +
        ' autocomplete="off" ' +
        ' spellcheck="false" role="searchbox" aria-autocomplete="list" />' +
        '</span>'
    );

    this.$searchContainer = $search;
    this.$search = $search.find('input');

    this.$search.prop('autocomplete', this.options.get('autocomplete'));

    $rendered.prepend($search);

    return $rendered;
};


var KEYS = $.fn.select2.amd.require('select2/keys');
$.fn.select2.amd.require('select2/core').prototype._registerEvents = function () {
    var self = this;

    this.on('open', function () {
        self.$container[0].classList.add('select2-container--open');
    });

    this.on('close', function () {
        self.$container[0].classList.remove('select2-container--open');
    });

    this.on('enable', function () {
        self.$container[0].classList.remove('select2-container--disabled');
    });

    this.on('disable', function () {
        self.$container[0].classList.add('select2-container--disabled');
    });

    this.on('blur', function () {
        self.$container[0].classList.remove('select2-container--focus');
    });

    this.on('query', function (params) {
        if (!self.isOpen()) {
            self.trigger('open', {});
        }

        this.dataAdapter.query(params, function (data) {
            self.trigger('results:all', {
                data: data,
                query: params
            });
        });
    });

    this.on('query:append', function (params) {
        this.dataAdapter.query(params, function (data) {
            self.trigger('results:append', {
                data: data,
                query: params
            });
        });
    });


    /**
     * v nasledujcim kodu (this.on('keypress'...) je rozsireni, aby doslo k odeslani inputu
     * pri stisknuti enteru, ... k tomu se ale jeste muze stat, ze kdyz se otevre dropdown menu,
     * tak enter jen zavre menu a uz neudela odeslani, aby se to odeslani po enteru stalo ikdyz je menu
     * rozbalene, tak je nasledujici kod (porovnava, jestli se zmenil pocet polozek, pokud ne a byl stisknut enter,
     * tak se odesle formular)
     */
    var prevValCount = self.val().length;
    this.on('results:select',function (event){
        if(self.val().length !== prevValCount){
            //neco se zmenilo
        }else{
            //pocet polozek je stejny asi se jen zavrelo dropdown menu
            if(
                event.hasOwnProperty('originalEvent')&&
                'which' in event.originalEvent &&
                event.originalEvent.which === KEYS.ENTER
            ){
                var form = self.$element.closest('form');
                if (form.length > 0) {
                    form.submit();
                    event.originalEvent.preventDefault();
                    return;
                }
            }
        }
        prevValCount = self.val().length;
    });

    this.on('keypress', function (evt) { //<----- tady se menilo nastaveni klaves
        var key = evt.which;

        if (self.isOpen()) {
            if (key === KEYS.ESC ||
                (key === KEYS.UP && evt.altKey)) {
                self.close(evt);

                evt.preventDefault();
            } else if (key === KEYS.ENTER || key === KEYS.TAB) {
                self.trigger('results:select', {originalEvent: evt});

                evt.preventDefault();
            } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
                self.trigger('results:toggle', {originalEvent: evt});

                evt.preventDefault();
            } else if (key === KEYS.UP) {
                self.trigger('results:previous', {originalEvent: evt});

                evt.preventDefault();
            } else if (key === KEYS.DOWN) {
                self.trigger('results:next', {originalEvent: evt});

                evt.preventDefault();
            }
        } else {
            
            if(key === KEYS.ENTER){
                var form = self.$element.closest('form');
                if (form.length > 0) {
                    form.submit();
                    evt.preventDefault();
                    return;
                }
            }

            if (key === KEYS.ENTER || key === KEYS.SPACE ||
                (key === KEYS.DOWN && evt.altKey)) {
                self.open();

                evt.preventDefault();
            }
        }
    });
};


var Utils = $.fn.select2.amd.require('select2/utils');
$.fn.select2.amd.require('select2/results').prototype.bind =  function (container, $container) {

    //tady by mela byt zmena jen v "container.on('results:select', function..."
    //pridava se tam "originalEvent: evt.originalEvent," ostatni kod tu je jen proto, ze jsme nevedel kratsi zapis

    var self = this;

    var id = container.id + '-results';

    this.$results.attr('id', id);

    container.on('results:all', function (params) {
        self.clear();
        self.append(params.data);

        if (container.isOpen()) {
            self.setClasses();
            self.highlightFirstItem();
        }
    });

    container.on('results:append', function (params) {
        self.append(params.data);

        if (container.isOpen()) {
            self.setClasses();
        }
    });

    container.on('query', function (params) {
        self.hideMessages();
        self.showLoading(params);
    });

    container.on('select', function () {
        if (!container.isOpen()) {
            return;
        }

        self.setClasses();

        if (self.options.get('scrollAfterSelect')) {
            self.highlightFirstItem();
        }
    });

    container.on('unselect', function () {
        if (!container.isOpen()) {
            return;
        }

        self.setClasses();

        if (self.options.get('scrollAfterSelect')) {
            self.highlightFirstItem();
        }
    });

    container.on('open', function () {
        // When the dropdown is open, aria-expended="true"
        self.$results.attr('aria-expanded', 'true');
        self.$results.attr('aria-hidden', 'false');

        self.setClasses();
        self.ensureHighlightVisible();
    });

    container.on('close', function () {
        // When the dropdown is closed, aria-expended="false"
        self.$results.attr('aria-expanded', 'false');
        self.$results.attr('aria-hidden', 'true');
        self.$results.removeAttr('aria-activedescendant');
    });

    container.on('results:toggle', function () {
        var $highlighted = self.getHighlightedResults();

        if ($highlighted.length === 0) {
            return;
        }

        $highlighted.trigger('mouseup');
    });

    container.on('results:select', function (evt) {
        var $highlighted = self.getHighlightedResults();

        if ($highlighted.length === 0) {
            return;
        }

        var data = Utils.GetData($highlighted[0], 'data');

        if ($highlighted.hasClass('select2-results__option--selected')) {
            self.trigger('close', {});
        } else {
            self.trigger('select', {
                originalEvent: evt.originalEvent,
                data: data
            });
        }
    });

    container.on('results:previous', function () {
        var $highlighted = self.getHighlightedResults();

        var $options = self.$results.find('.select2-results__option--selectable');

        var currentIndex = $options.index($highlighted);

        // If we are already at the top, don't move further
        // If no options, currentIndex will be -1
        if (currentIndex <= 0) {
            return;
        }

        var nextIndex = currentIndex - 1;

        // If none are highlighted, highlight the first
        if ($highlighted.length === 0) {
            nextIndex = 0;
        }

        var $next = $options.eq(nextIndex);

        $next.trigger('mouseenter');

        var currentOffset = self.$results.offset().top;
        var nextTop = $next.offset().top;
        var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);

        if (nextIndex === 0) {
            self.$results.scrollTop(0);
        } else if (nextTop - currentOffset < 0) {
            self.$results.scrollTop(nextOffset);
        }
    });

    container.on('results:next', function () {
        var $highlighted = self.getHighlightedResults();

        var $options = self.$results.find('.select2-results__option--selectable');

        var currentIndex = $options.index($highlighted);

        var nextIndex = currentIndex + 1;

        // If we are at the last option, stay there
        if (nextIndex >= $options.length) {
            return;
        }

        var $next = $options.eq(nextIndex);

        $next.trigger('mouseenter');

        var currentOffset = self.$results.offset().top +
            self.$results.outerHeight(false);
        var nextBottom = $next.offset().top + $next.outerHeight(false);
        var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;

        if (nextIndex === 0) {
            self.$results.scrollTop(0);
        } else if (nextBottom > currentOffset) {
            self.$results.scrollTop(nextOffset);
        }
    });

    container.on('results:focus', function (params) {
        params.element[0].classList.add('select2-results__option--highlighted');
        params.element[0].setAttribute('aria-selected', 'true');
    });

    container.on('results:message', function (params) {
        self.displayMessage(params);
    });

    if ($.fn.mousewheel) {
        this.$results.on('mousewheel', function (e) {
            var top = self.$results.scrollTop();

            var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;

            var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
            var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();

            if (isAtTop) {
                self.$results.scrollTop(0);

                e.preventDefault();
                e.stopPropagation();
            } else if (isAtBottom) {
                self.$results.scrollTop(
                    self.$results.get(0).scrollHeight - self.$results.height()
                );

                e.preventDefault();
                e.stopPropagation();
            }
        });
    }

    this.$results.on('mouseup', '.select2-results__option--selectable',
        function (evt) {
            var $this = $(this);

            var data = Utils.GetData(this, 'data');

            if ($this.hasClass('select2-results__option--selected')) {
                if (self.options.get('multiple')) {
                    self.trigger('unselect', {
                        originalEvent: evt,
                        data: data
                    });
                } else {
                    self.trigger('close', {});
                }

                return;
            }

            self.trigger('select', {
                originalEvent: evt,
                data: data
            });
        });

    this.$results.on('mouseenter', '.select2-results__option--selectable',
        function (evt) {
            var data = Utils.GetData(this, 'data');

            self.getHighlightedResults()
                .removeClass('select2-results__option--highlighted')
                .attr('aria-selected', 'false');

            self.trigger('results:focus', {
                data: data,
                element: $(this)
            });
        });
}
